import { render, staticRenderFns } from "./orcamentos.vue?vue&type=template&id=c434a966&"
import script from "./orcamentos.vue?vue&type=script&lang=js&"
export * from "./orcamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports